
<template>
    
        <mars-view class="article-detail"><mars-view v-for="(item, index) in article.content" :key="index"><mars-view v-if="item.type === 'image'" class="article-image-wrapper"><mars-image class="article-image" :style="{
                    'max-width': item.width + 'px',
                }" :class="{'close-image': article.content[index - 1] && article.content[index - 1].type === 'image'}" :src="item.imageUrl" preview mode="widthFix"></mars-image></mars-view><mars-view v-else-if="item.type === 'sub-title'"><mars-view class="sub-title">{{ item.text }}</mars-view></mars-view><mars-view v-else-if="item.type === 'video'"><mars-video class="article-inside-video" :src="item.src" :poster="item.poster" :style="{height: item.wh * 100 + 'vw'}" :controls="true" object-fit="contain"></mars-video></mars-view><mars-view v-else class="article-p"><mars-rich-text :nodes="item.text"></mars-rich-text></mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.article-detail {
  padding: 0 17px 17px 17px;
  font-family: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB';
}
.article-detail .article-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}
.article-detail .article-image {
  margin: -5px 0;
}
.article-detail .close-image {
  margin: 20px 0;
}
.article-detail .article-p {
  margin: 0.18rem 0;
  font-size: 0.18rem;
  color: #1e1f24;
  line-height: 0.3rem;
}
.article-detail .sub-title {
  position: relative;
  margin: 0.1rem 0 0.17rem;
  font-size: 0.19rem;
  font-weight: 500;
  line-height: 1.5;
  text-indent: 0.1rem;
  color: #333;
}
.article-detail .sub-title:before {
  content: '';
  position: absolute;
  top: 6px;
  left: 0;
  width: 4px;
  height: 17px;
  background-color: #356fff;
}
.article-detail .article-inside-video {
  width: 100%;
  margin: 20px 0;
}

</style>
